import { Component } from '@angular/core';

@Component({
    selector: 'app-typography-cmp',
    templateUrl: 'typography.component.html'
})

export class TypographyComponent {}
